module.exports = __webpack_public_path__ + "static/img/rank1.52828024.svg";